import type { DriveStep } from 'driver.js';
import { useCallback } from 'react';
import { useManualDriver } from '/@/components/driverjs/useDriver';
import { _ } from '/@/locale';

export function useRvHomeHelpTour(steps: DriveStep[], canStartManualTour: boolean) {
    const { startTour } = useManualDriver(steps, {
        popoverTag: _('MIS PRODUCTORES'),
    });

    const startHelpTourFromIcon = useCallback(() => {
        if (!canStartManualTour || steps.length === 0) return;

        const appContent = document.querySelector('#app-content');
        if (appContent) {
            (appContent as HTMLElement).scrollTop = 0;
        }
        window.setTimeout(() => {
            startTour();
        }, 200);
    }, [canStartManualTour, startTour, steps.length]);

    return { startHelpTourFromIcon };
}
